<template>
  <div class="card">
    <h3>Luo uusi käyttäjä</h3>
    <form @submit.prevent="createUser" autocomplete="new-password">
      <base-input
        type="text"
        name="username"
        label="Käyttäjänimi"
        autocomplete="new-password"
        v-model="username"
        :errors="errors.username"
      />
      <base-input
        type="email"
        name="email"
        label="Sähköpostiosoite"
        autocomplete="new-password"
        v-model="email"
        :errors="errors.email"
      />
      <input type="password" style="display:none;" readonly />

      <base-input
        type="password"
        name="password"
        label="Salasana"
        autocomplete="new-password"
        v-model="password"
        :errors="errors.password"
      />
      <div class="select-field">
        <select name="select" id="select" v-model="selected">
          <option selected>Valitse yritys</option>
          <option
            v-for="company in sortedCompanies"
            :key="company.id"
            :value="company.name"
          >
            {{ company.name }}
          </option>
        </select>
      </div>
      <button class="button button__rounded button__submit" type="submit">
        <span>Lisää uusi käyttäjä</span>
      </button>
    </form>
    <div class="spinner" v-if="busy">
      <Loader />
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
// import db from "@/firebase/init";
import slugify from "slugify";
import { mapState } from "vuex";

import BaseInput from "@/components/BaseInput";
import Loader from "@/components/Loader";

export default {
  name: "AddUser",
  components: {
    BaseInput,
    Loader
  },
  data() {
    return {
      // url: "https://vuosikello-672a8.web.app/",
      username: null,
      email: null,
      password: null,
      selected: null,
      companyId: null,
      errors: {},
      busy: false,
    };
  },
  computed: {
    ...mapState(["user", "companies"]),
    sortedCompanies() {
      let companies = Object.keys(this.companies).map(key => {
        return this.companies[key];
      });
      return [...companies].sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    }
  },
  methods: {
    createUser() {
      this.busy = true;

      this.companyId = slugify(this.selected, {
        replacement: "-",
        remove: /[$*_+~()'"!\-:@]/g,
        lower: true
      });

      const user = {
        username: this.username,
        email: this.email,
        company: this.selected,
        companyId: this.companyId,
        createdAt: new Date()
      }

      var functions = firebase.app().functions('europe-west1');
      const createUserFunc = functions.httpsCallable('createUser')

      createUserFunc(user).then(() => {
        console.log("Käyttäjä on lisätty tietokantaan.");
        this.username = "";
        this.email = "";
        this.password = "";
        this.selected = 0;
        this.busy = false;
      }).catch(err => {
        this.busy = false;
        console.log("User: ", err);
      });

      // firebase
      //   .auth()
      //   .createUserWithEmailAndPassword(this.email, this.password)
      //   .then(cred => {
      //     console.log("Käyttäjä luotu.", cred.user);
      //     return db
      //       .collection("users")
      //       .doc(cred.user.uid)
      //       .set({
      //         id: cred.user.uid,
      //         username: this.username,
      //         email: this.email,
      //         company: this.selected,
      //         companyId: this.companyId,
      //         createdAt: new Date()
      //       });
      //   })
      //   .then(() => {
      //     console.log("Käyttäjä on lisätty tietokantaan.");
      //   })
      //   .catch(err => {
      //     console.log("User: ", err.message, err.code);
      //   });
    }
  },
  created() {
    // db.collection("companies").onSnapshot(snapshot => {
    //   this.companies = [];
    //   snapshot.forEach(doc => {
    //     let company = doc.data();
    //     company.id = doc.id;
    //     this.companies.push(company);
    //   });
    // });
  }
};
</script>

<style lang="scss">
.card {
  position: relative;

  .spinner {
    border-radius: 1.5rem;
    margin: auto;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #44444473;
  }
}
.select-field {
  position: relative;
  display: flex;
  width: 20rem;
  background: white;
  box-shadow: $shadow_sm;
  overflow: hidden;
  border-radius: 50rem;
  &:before {
    position: absolute;
    content: "";
    top: 0;
    right: 0;
    height: 100%;
    padding: 0 1.5rem;
    background: $lightred;
    pointer-events: none;
    transition: $transition;
  }
  &:after {
    content: "";
    position: absolute;
    display: inline-block;
    top: 10px;
    right: 1.25rem;
    width: 1rem;
    height: 1rem;
    padding: 3px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
  select {
    flex: 1;
    padding: 0.75rem 2rem;
    font-size: 1.6rem;
    color: white;
    cursor: pointer;

    appearance: none;
    outline: 0;
    box-shadow: none;
    border: 0;
    background: rgba($lightred, 0.75);
    background-image: none;
    &::-ms-expand {
      display: none;
    }
  }
}
</style>
